import React from "react";

import {
  Divider,
  Grid,
  Typography
} from "@material-ui/core";

import LiegenschaftChecklistDialog from "./tools/LiegenschaftChecklistDialog";

export default function CreditFieldGroupLiegenschaft(
  {
    renderCreditField,
    index,
    creditFunctions,
    portals,
    credit_id,
    metafields
  }) {

  return (
    <>
      {renderCreditField("objektdaten_liegenschaft" + index + "_objekt", 6, 4)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_type", 6, 4)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_object_type", 6, 4)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_nutzung", 6, 4)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_will_be_rented_out", 6, 3)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_mieteinnahmen", 6, 3, "euro")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_wird_verkauft", 6, 3)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_housing_subsidy", 6, 3)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_interim_financing_required", 6, 3,)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_collateralization", 6, 3)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_aktueller_marktwert", 6, 3, "euro")}
      <Grid item xs={12} md={12}>
      </Grid>
      {renderCreditField("objektdaten_liegenschaft" + index + "_objekt_plz", 4, 2)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_objekt_ort", 8, 4)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_objekt_strasse", 8, 4)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_objekt_hausnummer", 4, 2)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_floor", 6, 2)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_stairway", 6, 2)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_top", 6, 2)}
      <Grid item xs={12} md={12}>
      </Grid>
      {renderCreditField("objektdaten_liegenschaft" + index + "_bezirksgericht", 6, 3)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_grundbuch", 6, 3)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_ez", 6, 3)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_grundstuecksnummer", 6, 3)}
      <Grid item xs={12} md={12}>
      </Grid>
      {renderCreditField("objektdaten_liegenschaft" + index + "_owner", 12, 6)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_zusatzinfo", 12, 6)}
      <Grid item xs={12} md={12}>
      </Grid>

      <Grid item xs={12} md={12}>
        <Divider />
      </Grid>
      {renderCreditField("objektdaten_liegenschaft" + index + "_objekt_im_bau", 6, 3)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_baujahr", 6, 3)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_baubeginn", 6, 3)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_bauende", 6, 3)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_energiekennzahl", 6, 3)}
      <Grid item xs={12} md={12}>
        <Divider />
      </Grid>
      {renderCreditField("objektdaten_liegenschaft" + index + "_material", 6, 4)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_geschosse", 6, 4)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_orientierung", 6, 4)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_living_room_orientation", 6, 4)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_flat_orientation", 6, 4)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_fertigteilbauweise", 6, 4)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_ferienimmobilie", 6, 4)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_denkmalschutz", 6, 4)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_bauernhof", 6, 4)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_betreutes_wohnen", 6, 4)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_luxusobjekt", 6, 4)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_aufzug", 6, 4)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_kfzstellplaetze", 6, 4)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_negative_einflussfaktoren", 6, 4)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_beurteilung_der_ausstattung", 6, 4)}
      <Grid item xs={12} md={12}>
        <Typography variant="h5">Flächen</Typography>
      </Grid>
      {renderCreditField("objektdaten_liegenschaft" + index + "_grundstuecksflaeche", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_net_room_area", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_wohnflaeche", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_flaeche_vermietet", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_gewerbliche_flaeche", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_gewerbliche_flaeche_eigennutzung", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_flaeche_keller", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_flaeche_erdgeschoss", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_flaeche_obergeschoss", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_flaeche_weiteres_obergeschoss", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_flaeche_dachgeschoss", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_flaeche_loggia", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_flaeche_dachterrasse", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_flaeche_balkon", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_flaeche_garten", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_flaeche_terrasse", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_flaeche_wintergarten", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_flaeche_garage", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_flaeche_nebengebaeude", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_dachgeschoss", 12, 6)}
      <Grid item xs={12} md={12}>
        <Typography variant="h5">Sanierung Jahr</Typography>
      </Grid>
      {renderCreditField("objektdaten_liegenschaft" + index + "_sanierung_bauwerk", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_sanierung_dachdeckung", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_sanierung_aussenfassade", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_sanierung_allgemeinflaechen", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_sanierung_fenster", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_sanierung_heizung", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_sanierung_elektro_sanitaer", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_sanierung_maler_tapezierarbeiten", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_sanierung_innenputz_innentreppen", 12, 6, "label_before")}
      <Grid item xs={12} md={12}>
        <Typography variant="h5">Badezimmer</Typography>
      </Grid>
      {renderCreditField("objektdaten_liegenschaft" + index + "_badezimmer_anzahl", 12, 6, "label_before")}
      {renderCreditField("objektdaten_liegenschaft" + index + "_main_bathroom_facilities", 12, 6)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_badezimmer_badewanne", 12, 6)/* deprecated BA before API */}

      {renderCreditField("objektdaten_liegenschaft" + index + "_badezimmer_bidet_im_badezimmer", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_badezimmer_doppelwaschbecken", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_badezimmer_dusche", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_badezimmer_handwaschbecken_im_getrennten_wc", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_badezimmer_separate_fussbodenheizung", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_badezimmer_verfliesung_des_gesamten_bades", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_badezimmer_wc", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_badezimmer_wellnesselemente_im_badezimmer", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_badezimmer_zu_oeffnendes_fenster", 12, 6)/* deprecated BA before API */}
      <Grid item xs={12} md={12}>
        <Typography variant="h5">Heizung</Typography>
      </Grid>
      {renderCreditField("objektdaten_liegenschaft" + index + "_heizungssystem", 6, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_heizungsmedium", 6, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_heating_system", 6, 6)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_heating_system_type", 6, 6)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_additional_heating_system", 6, 6)}
      {creditFunctions.isChannelActive("bankaustria") && /* deprecated BA before API */ <>
        <Grid item xs={12} md={12}>
          <Typography>Zusätzliche Heizsysteme</Typography>
        </Grid>
        {renderCreditField("objektdaten_liegenschaft" + index + "_heizung_kachelofen", 12, 6)}
        {renderCreditField("objektdaten_liegenschaft" + index + "_heizung_klimaanlage", 12, 6)}
        {renderCreditField("objektdaten_liegenschaft" + index + "_heizung_wohnraumlueftung", 12, 6)}
        {renderCreditField("objektdaten_liegenschaft" + index + "_heizung_kamin", 12, 6)}
        {renderCreditField("objektdaten_liegenschaft" + index + "_heizung_solaranlage", 12, 6)}
        {renderCreditField("objektdaten_liegenschaft" + index + "_heizung_waermepumpe", 12, 6)}
      </>}
      <Grid item xs={12} md={12}>
        <Typography variant="h5">Außenbereich</Typography>
      </Grid>
      {renderCreditField("objektdaten_liegenschaft" + index + "_aussen_aufwaendige_gartengestaltung", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_aussen_carport", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_aussen_einfriedung", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_aussen_nicht_einsehbar", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_aussen_bewaesserung", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_aussen_gelaendegestaltung", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_aussen_schwimmbad", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_terrasse", 12, 4)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_wintergarten", 12, 4) /* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_nebengebaeude", 12, 4) /* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_outside_facilities", 12, 6)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_terrace", 12, 3)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_wintergarden_type", 12, 3)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_annex_type", 12, 3)}
      <Grid item xs={12} md={12}>
        <Typography variant="h5">KFZ / Garage</Typography>
      </Grid>
      {renderCreditField("objektdaten_liegenschaft" + index + "_garage_lage", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_garage_direkter_zugang_zum_wohnhaus", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_garage_massivbauweise", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_garage_wasseranschluss_in_der_garage", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_garage_ueberdachter_aussenzugang_zum_wohnhaus", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_parking_space", 12, 6)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_garage_location", 12, 6)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_garage_facilities", 12, 6)}


      <Grid item xs={12} md={12}>
        <Typography variant="h5">Weitere Ausstattung</Typography>
      </Grid>
      {renderCreditField("objektdaten_liegenschaft" + index + "_keller", 12, 8) /* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_basement_usage", 12, 6)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_ebenerdiger_ausgang_in_garten", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_basement_construction", 12, 6)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_rohbaukeller", 12, 6)/* deprecated BA before API */}

      {renderCreditField("objektdaten_liegenschaft" + index + "_roof_construction", 12, 8)}
      {renderCreditField("objektdaten_liegenschaft" + index + "_ausstattung_alarmanlage", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_ausstattung_elektrische_rollaeden", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_ausstattung_elektrisches_garagentor", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_ausstattung_exklusive_bodenbelaege", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_ausstattung_flaechenheizung", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_ausstattung_grosszuegige_belichtungsflaechen", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_ausstattung_hochwertige_innentueren", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_ausstattung_holzfenster_mit_aluvorsatzschale", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_ausstattung_lift", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_ausstattung_photovoltaikanlage", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_ausstattung_sauna", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_ausstattung_wintergarten", 12, 6)/* deprecated BA before API */}
      {renderCreditField("objektdaten_liegenschaft" + index + "_additional_facilities", 12, 12)}

      <Grid item xs={12} md={6}>
        <LiegenschaftChecklistDialog
          liegenschaftIndex={index}
          // creditFunctions={creditFunctions}
          portals={portals}
          credit_id={credit_id}
          metafields={metafields}
        />
      </Grid>
    </>
  );
}
